import { $api } from "../generated/client";

type UseGetShopKnownTagsParams = {
  shopId: string;
};

export default function useGetShopKnownTags({
  shopId,
}: UseGetShopKnownTagsParams) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/return-requests/known-tags",
    {
      params: {
        path: { shopId },
      },
    },
    { enabled: !!shopId, staleTime: 1000 * 60 * 10 },
  );
}
